import React, { useState, useEffect } from 'react';
import { Modal, Button, Switch, InputNumber, Tooltip } from 'antd';
import { CheckOutlined, DownOutlined, TagFilled, InfoCircleOutlined } from '@ant-design/icons';
import './PricingPlans.scss';
import { plans, bundles } from '../../data/data';
import { PORTAL_LINK } from '../../../../../../environments/env';
const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
];
const PricingPlans = ({
    visible,
    onClose,
    setAnnualSetting,
    selectedPlan,
    currentlyActiveSubscription,
    openPaymentConfirmationModal
}) => {
    const [annual, setAnnual] = useState(true);
    const [quantity, setQuantity] = useState({
        "Basic Bundle": 5,
        "Studio Bundle": 45,
        "ALL3D Enterprise": 1,
    });
    const [minQuantity,] = useState({
        "Basic Bundle": 5,
        "Studio Bundle": 45,
        "ALL3D Enterprise": 1,
    });
    const [expandedCards, setExpandedCards] = useState({});
    const [selectedPlanType, setSelectedPlanType] = useState("subscriptions");

    const toggleCard = (index) => {
        setExpandedCards(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    useEffect(() => {
        if (selectedPlan) {
            setSelectedPlanType(selectedPlan);
        }
    }, [selectedPlan]);

    const handleQuantityChange = (value, packageType) => {
        setQuantity((prev) => ({
            ...prev,
            [packageType]: value,
        }));
    };

    return (
        <Modal
            centered
            closable
            maskClosable={false}
            visible={visible}
            onCancel={onClose}
            footer={null}
            className="pricing-plans-modal"
            destroyOnClose={true}
            width={700}
        >

            <div className="pricing-plans-content">
                <div>
                    <div className="manrope f-20 w-500 black-085 lh-28 mb-24">
                        Select a bundle or a subscription
                    </div>

                    <div className={`subscription-selector-wrapper justify-space-between mb-40`}>
                        <div className="subscription-selector">

                             <div
                                className={`plan ${selectedPlanType === "subscriptions" ? "selected" : ""
                                    }`}
                                onClick={() => setSelectedPlanType("subscriptions")}>
                                <span className="manrope f-14 w-700 lh-22">Subscribe & Save</span>
                            </div>
                            <div
                                className={`plan ${selectedPlanType === "bundles" ? "selected" : ""}`}
                                onClick={() => setSelectedPlanType("bundles")}>
                                <span className="manrope f-14 w-700 lh-22">Buy a bundle</span>
                            </div>
                           
                        </div>

                        {selectedPlanType === "subscriptions" &&
                            <div className="switch-wrapper">
                                <span className={`manrope f-12 lh-20 black-085 ${annual ? 'w-500' : 'w-700'} mr-8`}>Monthly</span>
                                <Switch
                                    className='subscription-selector-switch'
                                    checked={annual}
                                    onChange={(checked) => {
                                        setAnnual(checked);
                                        setAnnualSetting(checked);
                                    }} />
                                <span className={`manrope f-12 lh-20 black-085 ${annual ? 'w-700' : 'w-500'} ml-8`}>Annually</span>
                                <div className={`ml-8 save-discount-bg ${annual ? 'blue' : 'gray'}`}>
                                    <span className={`manrope f-12 lh-20 ${annual ? 'w-700 blue-18' : 'w-500 black-085'}`}>Save 17%</span>
                                </div>
                            </div>}
                    </div>

                    {selectedPlanType === "subscriptions" &&
                        <>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                                {plans.map((plan, index) => (
                                    plan.plan_name !== "enterprise" && (
                                        <div style={{ gap: 24 }}>
                                            <div className="pricing-plan-card justify-space-between">
                                                <div>
                                                    <div className="card-subtitle manrope f-14 w-500 lh-20 black-085 mb-8">{plan.subtitle}</div>
                                                    <div className="manrope f-20 w-700 lh-32 black-085">
                                                        {plan.title}
                                                    </div>
                                                    <div className="manrope f-14 w-500 lh-24 black-085 mb-8">
                                                        {plan.description}
                                                    </div>
                                                    <div className="justify-space-between align-baseline" style={{ gap: 16 }}>
                                                        <div className="justify-in-start align-baseline">
                                                            <span className="manrope f-26 w-700 lh-40 black-085">
                                                                ${annual ? plan.price.toLocaleString() : plan.priceMonthly.toLocaleString()}
                                                            </span>
                                                            <span className="manrope f-16 w-500 lh-40 black-085">
                                                                /month
                                                            </span>
                                                        </div>
                                                        <div className="discount-wrapper">
                                                            <TagFilled className="discount-icon" />
                                                            <span className="discount manrope f-12 w-500 lh-20">{annual ? plan.discount : plan.discount_monthly}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="pricing-plans-actions">
                                                    <div className="manrope f-14 w-400 lh-22 black-085 mb-16 text-center" style={{ opacity: 0.6 }}>
                                                        {annual ? plan.monthlyPeriod : plan.monthlyPlusPeriod}
                                                    </div>
                                                    <Button
                                                        onClick={() => openPaymentConfirmationModal(plan.plan_name, 'subscription')}
                                                        className="schedule-button mb-8">
                                                        {(plan.plan_name == currentlyActiveSubscription || plan.annual_plan_name == currentlyActiveSubscription
                                                            ? 'Renew Subscription'
                                                            : `Switch to ${plan.package_type}`)}
                                                    </Button>
                                                    <div className="manrope f-12 w-400 lh-20 black-085 text-center">
                                                        {annual ? plan.get_more_text : plan.get_more_text_monthly}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`mobile-features-section ${!expandedCards[index] ? 'expanded-radius' : 'expanded-radius'}`}>
                                                <div
                                                    className={`mobile-features-header ${expandedCards[index] ? `expanded-border` : ''}`}
                                                    onClick={() => toggleCard(index)}>
                                                    <span className="manrope f-14 w-700 lh-22 black-085">Includes:</span>
                                                    <div className={`expand-arrow ${expandedCards[index] ? 'expanded' : ''}`}>
                                                        <DownOutlined className="manrope f-14 w-700 lh-14 black-085" />
                                                    </div>
                                                </div>

                                                {expandedCards[index] &&
                                                    <div className="mobile-features-content">
                                                        <div className="mobile-features-list">
                                                            {plan.feature_table.map((feature, index) => (
                                                                <div key={index} className="feature-row">
                                                                    <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                    <span className="feature-value justify-in-center">
                                                                        {feature.value ? (
                                                                            <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                        ) : feature.included ? (
                                                                            <div className="checkmark">
                                                                                <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="empty-cell"></div>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="advanced-features-header">
                                                            <img src="/img/ai_creator/ai-twinkle.svg" alt="sparkle" />
                                                            <span className="manrope f-12 w-700 lh-22 white">Plus, these advanced editing tools and features</span>
                                                        </div>

                                                        <div className="mobile-features-list">
                                                            {plan.advanced_feature_table.filter(f => !f.is3DFeature).map((feature, index) => (
                                                                feature.included!==null && <div key={index} className={`feature-row`}>
                                                                    <span className="feature-name manrope f-14 w-700 lh-22 black-085">
                                                                        {feature.name}
                                                                        {feature.toolTip && (
                                                                            <Tooltip title={feature.toolTip}>
                                                                                <InfoCircleOutlined className="ml-4" style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }} />
                                                                            </Tooltip>
                                                                        )}
                                                                    </span>
                                                                    <span className="feature-value justify-in-center">
                                                                        {feature.value ? (
                                                                            <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                        ) : feature.included ? (
                                                                            <div className="checkmark">
                                                                                <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                            </div>
                                                                        ) : ''}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {plan.advanced_feature_table.some(f => f.is3DFeature) && (
                                                            <>
                                                                <div className="advanced-features-header">
                                                                    <span className="manrope f-12 w-700 lh-22 white">3D Features</span>
                                                                </div>
                                                                <div className="mobile-features-list">
                                                                    {plan.advanced_feature_table.filter(f => f.is3DFeature).map((feature, index) => (
                                                                        feature.included && <div key={index} className={`feature-row`}>
                                                                            <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                            <span className="feature-value justify-in-center">
                                                                                {feature.value ? (
                                                                                    <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                                ) : feature.included ? (
                                                                                    <div className="checkmark">
                                                                                        <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                                    </div>
                                                                                ) : ''}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>}
                                            </div>
                                        </div>)))}
                            </div>

                            <div style={{ marginTop: 40 }}>
                                <div className="manrope f-20 w-500 lh-28 black-085 justify-in-start mb-24">
                                    Have a large team? Select our enterprise solution
                                </div>
                                {plans.map((plan, index) => (
                                    plan.plan_name == "enterprise" && (
                                        <>
                                            <div className="pricing-plan-card justify-space-between" style={{ gap: 24 }}>
                                                <div>
                                                    <div className="card-subtitle manrope f-14 w-500 lh-20 black-085 mb-8">{plan.subtitle}</div>
                                                    <div className="manrope f-20 w-700 lh-32 black-085">
                                                        {plan.title}
                                                    </div>
                                                    <div className="manrope f-16 w-500 lh-24 black-085 mb-8">
                                                        {plan.description}
                                                    </div>
                                                </div>

                                                <div className="pricing-plans-actions">
                                                    <div className="manrope f-14 w-400 lh-22 black-085 mb-16 text-center" style={{ opacity: 0.6 }}>
                                                        {annual ? plan.monthlyPeriod : plan.monthlyPlusPeriod}
                                                    </div>
                                                    <Button
                                                        onClick={() => window.location.href = `${PORTAL_LINK}contact-us`}
                                                        className="schedule-button mb-8">
                                                        {plan.buttonText}
                                                    </Button>
                                                    <div className="manrope f-12 w-400 lh-20 black-085 text-center">
                                                        {annual ? plan.get_more_text : plan.get_more_text_monthly}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`mobile-features-section ${!expandedCards[index] ? 'expanded-radius' : 'expanded-radius'}`}>
                                                <div
                                                    className={`mobile-features-header ${expandedCards[index] ? `expanded-border` : ''}`}
                                                    onClick={() => toggleCard(index)}>
                                                    <span className="manrope f-14 w-700 lh-22 black-085">Includes:</span>
                                                    <div className={`expand-arrow ${expandedCards[index] ? 'expanded' : ''}`}>
                                                        <DownOutlined className="manrope f-14 w-700 lh-14 black-085" />
                                                    </div>
                                                </div>

                                                {expandedCards[index] &&
                                                    <div className="mobile-features-content">
                                                        <div className="mobile-features-list">
                                                            {plan.feature_table.map((feature, index) => (
                                                                <div key={index} className="feature-row">
                                                                    <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                    <span className="feature-value justify-in-center">
                                                                        {feature.value ? (
                                                                            <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                        ) : feature.included ? (
                                                                            <div className="checkmark">
                                                                                <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                            </div>
                                                                        ) : (
                                                                            <div className="empty-cell"></div>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="advanced-features-header">
                                                            <img src="/img/ai_creator/ai-twinkle.svg" alt="sparkle" />
                                                            <span className="manrope f-12 w-700 lh-22 white">Plus, these advanced editing tools and features</span>
                                                        </div>

                                                        <div className="mobile-features-list">
                                                            {plan.advanced_feature_table.filter(f => !f.is3DFeature).map((feature, index) => (
                                                                feature.included && <div key={index} className={`feature-row`}>
                                                                    <span className="feature-name manrope f-14 w-700 lh-22 black-085">
                                                                        {feature.name}
                                                                        {feature.toolTip && (
                                                                            <Tooltip title={feature.toolTip}>
                                                                                <InfoCircleOutlined className="ml-4" style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }} />
                                                                            </Tooltip>
                                                                        )}
                                                                    </span>
                                                                    <span className="feature-value justify-in-center">
                                                                        {feature.value ? (
                                                                            <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                        ) : feature.included ? (
                                                                            <div className="checkmark">
                                                                                <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                            </div>
                                                                        ) : ''}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {plan.advanced_feature_table.some(f => f.is3DFeature) && (
                                                            <>
                                                                <div className="advanced-features-header">
                                                                    <span className="manrope f-12 w-700 lh-22 white">3D Features</span>
                                                                </div>
                                                                <div className="mobile-features-list">
                                                                    {plan.advanced_feature_table.filter(f => f.is3DFeature).map((feature, index) => (
                                                                        feature.included && <div key={index} className={`feature-row`}>
                                                                            <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                            <span className="feature-value justify-in-center">
                                                                                {feature.value ? (
                                                                                    <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                                ) : feature.included ? (
                                                                                    <div className="checkmark">
                                                                                        <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                                    </div>
                                                                                ) : ''}
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>}
                                            </div>
                                        </>)))}
                            </div>
                        </>}



                    {selectedPlanType === "bundles" && <>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                            {bundles.map((bundle, index) => (
                                bundle.title !== "ALL3D Enterprise" && (
                                    <div style={{ gap: 24 }}>
                                        <div className="pricing-plan-card justify-space-between" >
                                            <div>
                                                <div className="card-subtitle manrope f-14 w-500 lh-20 black-085 mb-8">{bundle.subtitle}</div>
                                                <div className="manrope f-20 w-700 lh-32 black-085">
                                                    {bundle.title}
                                                </div>
                                                <div className="manrope f-16 w-500 lh-24 black-085 mb-8">
                                                    {bundle.description}
                                                </div>
                                                <div className="justify-space-between align-baseline" style={{ gap: 16 }}>
                                                    <div className="justify-in-start align-baseline">
                                                        <span className="manrope f-26 w-700 lh-40 black-085">
                                                            ${bundle.price.toLocaleString()} 
                                                        </span>
                                                        <span className="manrope f-16 w-500 lh-40 black-085">
                                                            /product
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="pricing-plans-actions">
                                                <div className="justify-space-between mb-16">
                                                    {bundle.price == 0 ? '' :
                                                        <div className="justify-in-end">
                                                            <div className="manrope f-10 lh-22 black-085 w-500 mr-8">QTY</div>
                                                            <InputNumber
                                                                min={minQuantity[bundle.title] || 1}
                                                                value={quantity[bundle.title]}
                                                                onKeyDown={(e) => {
                                                                    if ((["-", ".", " "].includes(e.key)) || (/[a-zA-Z\s]/.test(e.key) && !allowedKeys.includes(e.key))) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                onChange={(value) => handleQuantityChange(value, bundle.title)}
                                                                className="quantity-input manrope f-14 lh-22 black-085 w-400" />
                                                        </div>}

                                                    <div className="manrope f-14 w-400 lh-22 black-085 text-center" style={{ opacity: 0.6 }}>
                                                        {bundle.image_length}
                                                    </div>
                                                </div>
                                                <Button
                                                    onClick={() => openPaymentConfirmationModal(bundle.name, 'bundle', quantity[bundle.title] || 1)}
                                                    className="schedule-button mb-8">
                                                    {bundle.buttonText}&nbsp;
                                                    {quantity[bundle.title] * bundle.credit_multiplier} credits
                                                </Button>
                                                <div className="manrope f-12 w-400 lh-20 black-085 text-center">
                                                    {bundle.credit_multiplier} credits per image. All {quantity[bundle.title] * bundle.credit_multiplier} credits available at once.
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`mobile-features-section ${!expandedCards[index] ? 'expanded-radius' : 'expanded-radius'}`}>
                                            <div
                                                className={`mobile-features-header ${expandedCards[index] ? `expanded-border` : ''}`}
                                                onClick={() => toggleCard(index)}>
                                                <span className="manrope f-14 w-700 lh-22 black-085">Includes:</span>
                                                <div className={`expand-arrow ${expandedCards[index] ? 'expanded' : ''}`}>
                                                    <DownOutlined className="manrope f-14 w-700 lh-14 black-085" />
                                                </div>
                                            </div>

                                            {expandedCards[index] &&
                                                <div className="mobile-features-content">
                                                    <div className="mobile-features-list">
                                                        {bundle.feature_table.map((feature, index) => (
                                                            <div key={index} className="feature-row">
                                                                <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                <span className="feature-value justify-in-center">
                                                                    {feature.value ? (
                                                                        <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                    ) : feature.included ? (
                                                                        <div className="checkmark">
                                                                            <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="empty-cell"></div>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="advanced-features-header">
                                                        <img src="/img/ai_creator/ai-twinkle.svg" alt="sparkle" />
                                                        <span className="manrope f-12 w-700 lh-22 white">Plus, these advanced editing tools and features</span>
                                                    </div>

                                                    <div className="mobile-features-list">
                                                        {bundle.advanced_feature_table?.filter(f => !f.is3DFeature).map((feature, index) => (
                                                            <div key={index} className={`feature-row`}>
                                                                <span className="feature-name manrope f-14 w-700 lh-22 black-085">
                                                                    {feature.name}
                                                                    {feature.toolTip && (
                                                                        <Tooltip title={feature.toolTip}>
                                                                            <InfoCircleOutlined className="ml-4" style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }} />
                                                                        </Tooltip>
                                                                    )}
                                                                </span>
                                                                <span className="feature-value justify-in-center">
                                                                    {feature.value ? (
                                                                        <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                    ) : feature.included ? (
                                                                        <div className="checkmark">
                                                                            <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="empty-cell"></div>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {bundle.advanced_feature_table?.some(f => f.is3DFeature) && (
                                                        <>
                                                            <div className="advanced-features-header">
                                                                <span className="manrope f-12 w-700 lh-22 white">3D Features</span>
                                                            </div>
                                                            <div className="mobile-features-list">
                                                                {bundle.advanced_feature_table.filter(f => f.is3DFeature).map((feature, index) => (
                                                                    feature.included && <div key={index} className={`feature-row`}>
                                                                        <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                        <span className="feature-value justify-in-center">
                                                                            {feature.value ? (
                                                                                <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                            ) : feature.included ? (
                                                                                <div className="checkmark">
                                                                                    <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                                </div>
                                                                            ) : ''}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>}
                                        </div>
                                    </div>)))}
                        </div>
                        <div style={{ marginTop: 40 }}>
                            <div className="manrope f-20 w-500 lh-28 black-085 justify-in-start mb-24">
                                Have a large team? Select our enterprise solution
                            </div>
                            {bundles.map((bundle, index) => (
                                bundle.title == "ALL3D Enterprise" && (
                                    <div>
                                        <div className="pricing-plan-card justify-space-between">
                                            <div>
                                                <div className="card-subtitle manrope f-14 w-500 lh-20 black-085 mb-8">{bundle.subtitle}</div>
                                                <div className="manrope f-20 w-700 lh-32 black-085">
                                                    {bundle.title}
                                                </div>
                                                <div className="manrope f-16 w-500 lh-24 black-085 mb-8">
                                                    {bundle.description}
                                                </div>

                                            </div>

                                            <div className="pricing-plans-actions">
                                                <div className="manrope f-14 w-400 lh-22 black-085 mb-16 text-center" style={{ opacity: 0.6 }}>
                                                    {bundle.image_length}
                                                </div>
                                                <Button
                                                    onClick={() => window.location.href = `${PORTAL_LINK}contact-us`}
                                                    className="schedule-button mb-8">
                                                    {bundle.buttonText}
                                                </Button>
                                                <div className="manrope f-12 w-400 lh-20 black-085 text-center">
                                                    {bundle.get_more_text}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`mobile-features-section ${!expandedCards[index] ? 'expanded-radius' : 'expanded-radius'}`}>
                                            <div
                                                className={`mobile-features-header ${expandedCards[index] ? `expanded-border` : ''}`}
                                                onClick={() => toggleCard(index)}>
                                                <span className="manrope f-14 w-700 lh-22 black-085">Includes:</span>
                                                <div className={`expand-arrow ${expandedCards[index] ? 'expanded' : ''}`}>
                                                    <DownOutlined className="manrope f-14 w-700 lh-14 black-085" />
                                                </div>
                                            </div>

                                            {expandedCards[index] &&
                                                <div className="mobile-features-content">
                                                    <div className="mobile-features-list">
                                                        {bundle.feature_table.map((feature, index) => (
                                                            <div key={index} className="feature-row">
                                                                <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                <span className="feature-value justify-in-center">
                                                                    {feature.value ? (
                                                                        <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                    ) : feature.included ? (
                                                                        <div className="checkmark">
                                                                            <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="empty-cell"></div>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="advanced-features-header">
                                                        <img src="/img/ai_creator/ai-twinkle.svg" alt="sparkle" />
                                                        <span className="manrope f-12 w-700 lh-22 white">Plus, these advanced editing tools and features</span>
                                                    </div>

                                                    <div className="mobile-features-list">
                                                        {bundle.advanced_feature_table?.filter(f => !f.is3DFeature).map((feature, index) => (
                                                            <div key={index} className={`feature-row`}>
                                                                <span className="feature-name manrope f-14 w-700 lh-22 black-085">
                                                                    {feature.name}
                                                                    {feature.toolTip && (
                                                                        <Tooltip title={feature.toolTip}>
                                                                            <InfoCircleOutlined className="ml-4" style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }} />
                                                                        </Tooltip>
                                                                    )}
                                                                </span>
                                                                <span className="feature-value justify-in-center">
                                                                    {feature.value ? (
                                                                        <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                    ) : feature.included ? (
                                                                        <div className="checkmark">
                                                                            <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                        </div>
                                                                    ) : (
                                                                        <div className="empty-cell"></div>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {bundle.advanced_feature_table?.some(f => f.is3DFeature) && (
                                                        <>
                                                            <div className="advanced-features-header">
                                                                <span className="manrope f-12 w-700 lh-22 white">3D Features</span>
                                                            </div>
                                                            <div className="mobile-features-list">
                                                                {bundle.advanced_feature_table.filter(f => f.is3DFeature).map((feature, index) => (
                                                                    feature.included && <div key={index} className={`feature-row`}>
                                                                        <span className="feature-name manrope f-14 w-700 lh-22 black-085">{feature.name}</span>
                                                                        <span className="feature-value justify-in-center">
                                                                            {feature.value ? (
                                                                                <span className="manrope f-14 w-500 lh-22 black-085 text-center">{feature.value}</span>
                                                                            ) : feature.included ? (
                                                                                <div className="checkmark">
                                                                                    <CheckOutlined className="manrope f-12 lh-12 w-700 white" />
                                                                                </div>
                                                                            ) : ''}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    )}
                                                </div>}
                                        </div>
                                    </div>)))}
                        </div>
                    </>}
                </div>
            </div>
        </Modal>
    );
};

export default PricingPlans;

